import { useEffect } from 'react';
import { setFieldDisabled } from '../../../stream/transfer/control';
import useControlNext from '../../state/useControlNext';
const useDisabledSync = ({ disabled, fieldName, fieldIndices })=>{
    const next = useControlNext();
    useEffect(()=>{
        next(setFieldDisabled({
            fieldName,
            fieldIndices,
            disabled
        }));
    }, [
        disabled,
        fieldName,
        fieldIndices,
        next
    ]);
};
export default useDisabledSync;
